/*=========================================================================================
  File Name: moduleCompanyState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	countries: [],
	cities: [],
	departments: [],
	dataSelectVisitPoint: [],
	role: [],
	status: [],
	category: [],
	typology: [],
};
